<div style="margin: 10px 10px 10px 10px;">
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">DNS/Hostname:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [formControl]="dnsHostname" />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">IP Address:</span>
				<div class="col-lg-3">
					<input type="text" class="col-lg-3 form-control" [formControl]="hostIpAddress" />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">MAC Address:</span>
				<div class="col-lg-3">
					<input type="text" class="col-lg-3 form-control" [formControl]="hostMacAddress" />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">&nbsp;</span>
				<div class="col-lg-3"
					style="height: 60px; display: flex; justify-content: center; align-items: center;">
					<button [disabled]="!enableLookup" type="button" pButton label="Lookup" (click)="lookup()"></button>
					<button type="button" pButton label="Reset" (click)="resetFields()"></button>
				</div>
				<div class="col-lg-2" style="height: 60px; display: flex; justify-content: left; align-items: center;">
					<input type="checkbox" [formControl]="doLive" />
					<span class="uv-checkbox-label">Live</span>
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">Switch Name:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="switchName" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">IP Address:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="ipAddress" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">Slot/Module:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="slotModule" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">Port:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="port" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">VLAN:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="vlan" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">Jack Building:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="jackBuilding" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">Jack Room:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="jackRoom" readonly />
				</div>
			</div>
		</div>
		<div class="form-group row mb-3">
			<div class="uv-row">
				<span class="col-lg-3">&nbsp;</span>
				<span class="col-lg-2">Jack Label:</span>
				<div class="col-lg-3">
					<input type="text" class="form-control" [value]="jackLabel" readonly />
				</div>
			</div>
		</div>

	</form>
</div>
